import React from 'react'
import { useSelector } from 'react-redux'
import 'resources/fonts/style.scss'
import './iconCard.scss'

const IconCard = ({ edit, idSelected, inline, disabled, displayNotification, onClick, iconType, title, description }) => {
  const user = useSelector((state) => state.userReducer.user)
  const notifications = useSelector((state) => state.notificationReducer.notifications)

  const renderStateOfCard = () => {
    let cardClassNames = 'card-container'
    if (edit) {
      cardClassNames += ' edit'
    }
    if (idSelected) {
      cardClassNames += ' selected-card'
    }
    if (inline) {
      cardClassNames += ' inline ml-0'
    }
    if (disabled) {
      cardClassNames += ' noHover'
    }
    return cardClassNames
  }

  return (
    <div className={`${renderStateOfCard()} position-relative`} onClick={onClick}>
      {displayNotification && notifications > 0 && user.roles.some((role) => role === 'ORFI-MANAGER' || role === 'ORFI-DIRECTEUR') && (
        <div className="notification-bell">
          <div className="notification">
            <span>{notifications > 99 ? '99+' : notifications}</span>
          </div>
        </div>
      )}
      <div className={`${inline ? 'd-flex' : ''}`}>
        <div className={inline ? 'center-item' : 'icon-container'}>
          <span className={`icon-card ${iconType}`} />
        </div>
        <div className={inline ? 'inline-title center-item' : 'content-card'}>
          {!edit && <p className="title-card">{title}</p>}
          <span className="description-card">{description}</span>
        </div>
      </div>
    </div>
  )
}

export default IconCard
